import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useCustomSnackbar } from '../../../../hooks/useCustomEnqueueSnackbar';
import { userInfoApi } from '../../../../services/apiServices/user/userInfo';
import { ButtonClassNames } from '../../../../models/Common';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';
import { AnimatedIcon } from '../../AnimatedIcon';
import WarningIconLight from '../../../../assets/images/lottieIcons/warning/warning.light.json';
import WarningIconDark from '../../../../assets/images/lottieIcons/warning/warning.dark.json';
import { getErrorMessage } from '../../../../utils';

interface IDeleteAccount {
  userId: number | string | undefined;
  handleClose: () => void;
}

export const DeleteAccount: FC<IDeleteAccount> = ({ userId, handleClose }) => {
  const { t } = useTranslation();
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const [deleteMember, { isLoading }] = userInfoApi.useDeleteMemberAccountMutation();

  const handleContinue = async () => {
    try {
      await deleteMember({ userId: Number(userId) }).unwrap();
      customEnqueueSnackbar(t('multiAccount.accountWasRemoved', { userId }), 'success');
      handleClose();
    } catch (err) {
      const message = getErrorMessage(err);
      customEnqueueSnackbar(message, 'error');
    }
  };

  return (
    <div className="modals">
      <div className="modals__header modals__header__top-up">
        <AnimatedIcon lightIcon={WarningIconLight} darkIcon={WarningIconDark} className="icon-warning" />
        <article className="modals__header__title">{t('multiAccount.deleteFromAccounts')}</article>
        <p className="modals__header__description">{t('multiAccount.youWillLoseAccess')}</p>
      </div>
      <div className="modals__btn-group">
        <CustomMUIButton
          label={t('multiAccount.cancel')}
          handleClick={handleClose}
          className={ButtonClassNames.SecondaryOutlined}
          isBold
        />
        <CustomMUIButton
          label={t('multiAccount.delete')}
          handleClick={handleContinue}
          className={ButtonClassNames.PrimaryFulfilled}
          isLoading={isLoading}
          isBold
        />
      </div>
    </div>
  );
};
